import React,{ useState, useEffect } from 'react';
import {  Button, IconButton, Box, Typography} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


/**
 * A React component that renders a single computer button.
 * 
 * @param {Object} props - The component props.
 * @param {string} props.text - The text to display on the button. Defaults to 'Single Computer'.
 * @param {string} props.variant - The button variant. Defaults to 'outlined'.
 * @param {string} props.color - The button color. Defaults to 'primary'.
 * @param {Function} props.onClick - The callback function to call when the button is clicked.
 */
const SingleComputer = ({
  text,
  variant,
  color,
  onClick,
  handleSingleComputerDecrement,
  reset
}) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
  
      setCount(0);
 
  }, [reset]);
  const handleIncrement = () => {
    const added = onClick();
    if (added) {
      setCount(prevCount => prevCount + 1);
    }
  };

  /**
   * Handles the decrement button click.
   * 
   * @returns {void}
   */
  const handleDecrement = () => {
    handleSingleComputerDecrement();
    if (count > 0) {
      setCount(prevCount => prevCount - 1);
    }
  };
  return (
    <Box display="flex" alignContent="center" alignItems="center" sx={{ width: '100%' }}>
      <Button
        size="small"
        variant={variant || 'outlined'}
        color={color || 'primary'}
        onClick={() => handleIncrement()}
        sx={{
          fontFamily: 'Open Sans',
          color: '#363636',
          width: { xs: '100%', sm: '90%', md: '70%' },
          height: { xs: '40px', sm: '40px' },
          padding: { xs: '8px 12px', sm: '10px 16px' },
          margin: '0 auto',
          textTransform: 'none',
          whiteSpace: 'normal',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: 'clamp(10px, 4vw, 16px)',
          lineHeight: '1.2',
          maxHeight: '60px'
        }}
      >{text || 'Single Computer'}
      </Button>
      <Typography
        variant="body1"
        sx={{
          fontSize: 'clamp(12px, 2.5vw, 16px)',
          minWidth: '30px',
          textAlign: 'center',
          flexShrink: 0
        }}
      >
        {count}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <IconButton
          onClick={handleIncrement}
          sx={{
            border: '1px solid #363636',
            borderRadius: '50%',
            padding: '5px',
            fontSize: 'clamp(12px, 2.5vw, 16px)'
          }}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          onClick={handleDecrement}
          sx={{
            border: '1px solid #363636',
            borderRadius: '50%',
            padding: '5px',
            fontSize: 'clamp(12px, 2.5vw, 16px)'
          }}
        >
          <RemoveIcon />
        </IconButton>
      </Box>
    </Box>
  )
}

/**
 * Exports the SingleComputer component as the default export.
 */
export default SingleComputer;